// @flow
import { ATTEMPT_LOAD_COUNTRY_CONFIG, CHANGE_ENV, ENVIRONMENT_CONFIG, LOAD_COUNTRY_CONFIG } from './constants';

import defaultConfig from '~/core/config/default';
import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import { merge, reduce } from 'lodash/fp';

const mergeConfig = (defaultConfig, env, countryConfig = {}) =>
    reduce((all, current) => merge(all, current), {}, [defaultConfig, countryConfig, env]);

const actionHandlers = {
    [ATTEMPT_LOAD_COUNTRY_CONFIG]: handleReduce(state =>
        // $FlowFixMe
        state.withMutations(map => map.set('loadingCountryConfig', true).set('error', false))
    ),
    [LOAD_COUNTRY_CONFIG]: handleReduce(
        (state, { payload: countryConfig }) => {
            // $FlowFixMe
            const newState = state.withMutations(map =>
                map
                    .mergeIn(['mergedConfig'], fromJS(mergeConfig(defaultConfig, ENVIRONMENT_CONFIG, countryConfig)))
                    .set('loadingCountryConfig', false)
            );

            mergedConfig = newState.get('mergedConfig');

            return newState;
        },
        // $FlowFixMe
        state => state.set('error', true)
    ),
    [CHANGE_ENV]: handleReduce((state, { payload }) => {
        mergedConfig = calculateConfig(payload);
        // $FlowFixMe
        return state.set('mergedConfig', mergedConfig);
    })
};

const calculateConfig = env => fromJS(mergeConfig(defaultConfig, env));

// This is an escape hatch to help parts of the app that are unable to use config from the application
// state because of where they run (mainly during startup).
// PLEASE TRY NOT TO USE THIS (VIA `getFromConfig`)
let mergedConfig = calculateConfig(ENVIRONMENT_CONFIG);

// $FlowFixMe
export const getFromConfig = (key: string) => mergedConfig.getIn(key.split(':'));

export default handleActions(
    actionHandlers,
    fromJS({
        mergedConfig: mergedConfig,
        locales: process.locales || []
    })
);



// WEBPACK FOOTER //
// ./src/core/state/config/index.js